import React from "react";
import { MdCall, MdCheckCircle } from "react-icons/md";

const EventCard = ({ event, onClick, isMobile = false }) => {
    // Format time
    const timeStr = event.time.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    // Determine color based on type
    const typeColor = event.type === "lead" ? "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200" : "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200";
    const typeBgHover = event.type === "lead" ? "hover:bg-blue-200 dark:hover:bg-blue-800" : "hover:bg-purple-200 dark:hover:bg-purple-800";

    // Truncate name based on screen
    const displayName = isMobile
        ? (event.name.length > 25 ? event.name.substring(0, 22) + "..." : event.name)
        : (event.name.length > 18 ? event.name.substring(0, 15) + "..." : event.name);

    const statusBadgeColor = event.status === "completed"
        ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
        : event.status === "scheduled"
            ? "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200"
            : "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200";

    if (isMobile) {
        return (
            <button
                onClick={onClick}
                className={`w-full text-left p-3 rounded-md transition-all duration-200 border border-current border-opacity-40 ${typeColor} ${typeBgHover}`}
                title={event.name}
            >
                <div className="space-y-2">
                    {/* Header: Time and Status */}
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                            <MdCall className="h-4 w-4 flex-shrink-0" />
                            <span className="font-semibold text-sm">{timeStr}</span>
                        </div>
                        <span className={`px-2 py-1 text-xs font-semibold rounded-full capitalize ${statusBadgeColor}`}>
                            {event.status}
                        </span>
                    </div>

                    {/* Name */}
                    <p className="font-bold text-sm truncate">{displayName}</p>

                    {/* Details */}
                    <div className="text-xs space-y-0.5">
                        {event.phone && (
                            <p className="text-opacity-80">📱 {event.phone}</p>
                        )}
                        {event.note && (
                            <p className="text-opacity-80 line-clamp-2">{event.note}</p>
                        )}
                    </div>
                </div>
            </button>
        );
    }

    // Desktop/Tablet layout
    return (
        <button
            onClick={onClick}
            className={`w-full text-left p-2 rounded-md text-xs font-semibold transition-all duration-200 flex flex-col gap-0.5 ${typeColor} ${typeBgHover} border border-current border-opacity-40`}
            title={event.name}
        >
            <div className="flex items-center gap-1.5 min-w-0">
                <MdCall className="h-3.5 w-3.5 flex-shrink-0" />
                <span className="truncate">{displayName}</span>
            </div>
            <div className="text-opacity-85 ml-5">{timeStr}</div>
        </button>
    );
};

export default EventCard;
